import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfHistoryIconProps extends SvgIconProps {}
/**
 * This icon will be used to display unavailable status of agent
 * @param props - CcfHelpIcon
 * @example - <CcfHelpIcon />
 * @returns SVG of unavailable icon
 */
export function CcfHistoryIcon(props: CcfHistoryIconProps) {
  return (
    <SvgIcon {...props} width="34" height="34" fill="none" viewBox="0 0 34 34">
      <path
        d="M12.001 12V7.98C12.001 7.317 11.464 6.78 10.801 6.78C10.138 6.78 9.60098 7.317 9.60098 7.98V13.572C9.60098 14.136 10.537 14.4 11.101 14.4H18.301C18.964 14.4 19.501 13.863 19.501 13.2C19.501 12.537 18.964 12 18.301 12H12.001Z"
        fill="#ffb000"
      />
      <path
        d="M12.001 0C5.37323 0 0.000976562 5.37225 0.000976562 12C0.000976562 18.6278 5.37323 24 12.001 24C18.6287 24 24.001 18.6278 24.001 12C24.001 5.37225 18.6287 0 12.001 0ZM12.001 21.6C6.69923 21.6 2.40098 17.3018 2.40098 12C2.40098 6.69825 6.69923 2.4 12.001 2.4C17.3027 2.4 21.601 6.69825 21.601 12C21.601 17.3018 17.3027 21.6 12.001 21.6Z"
        fill="#ffb000"
      />
    </SvgIcon>
  );
}

export default CcfHistoryIcon;
